import IosApp from './ios-app';

export default {
  IosApp,
};
